(function () {
  "use strict";

  var backendBaseUrl = window.STUDIO_MYA_EXTERNAL_CHECKOUT_URL;
  var isRedirecting = false;

  if (!backendBaseUrl) {
    return;
  }

  backendBaseUrl = String(backendBaseUrl).replace(/\/$/, "");
  renderCheckoutSuccessIfNeeded();
  renderThemeCheckoutIfNeeded();

  function isBuyNowTarget(element) {
    var buttonText = "";

    try {
      buttonText = String(element.closest("button, a, [role='button']")?.textContent || "").trim().toLowerCase();
    } catch (_error) {
      buttonText = "";
    }

    return Boolean(
      element &&
        element.closest(
          [
            ".shopify-payment-button__button",
            ".shopify-payment-button__button--unbranded",
            ".shopify-payment-button button",
            "shopify-buy-it-now-button",
            "shopify-buy-it-now-button button",
            "button[data-testid='Checkout-button']",
            "button[data-testid*='Buy']",
            "button[data-testid*='buy']",
            "[data-studio-buy-now]",
            "[data-shopify='payment-button']",
            "[data-testid='ShopifyPay-button']",
          ].join(","),
        )
    ) || /^(acheter maintenant|buy it now|buy now)$/i.test(buttonText);
  }

  function isCheckoutTarget(element) {
    if (!element) {
      return false;
    }

    var button = element.closest('button[name="checkout"], input[name="checkout"], [data-testid="Checkout-button"]');
    if (button) {
      return true;
    }

    var link = element.closest('a[href]');
    if (link) {
      try {
        var url = new URL(link.getAttribute("href"), window.location.origin);
        if (
          url.pathname === "/checkout" ||
          url.pathname.indexOf("/checkout/") === 0 ||
          url.pathname === "/checkouts" ||
          url.pathname.indexOf("/checkouts/") === 0
        ) {
          return true;
        }
      } catch (_error) {
        return false;
      }
    }

    return isBuyNowTarget(element);
  }

  function neutralizeBuyNowButtons() {
    var selectors = [
      "shopify-buy-it-now-button button",
      ".shopify-payment-button__button",
      ".shopify-payment-button__button--unbranded",
      ".shopify-payment-button button",
      "shopify-accelerated-checkout",
      "shopify-accelerated-checkout-cart",
      "[data-studio-buy-now]",
    ].join(",");
    var buttons = document.querySelectorAll(selectors);

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];

      if (button.dataset.externalCheckoutPatched === "1") {
        continue;
      }

      button.dataset.externalCheckoutPatched = "1";
      button.addEventListener("click", handleCheckout, true);
    }
  }

  function neutralizeNativeCheckoutLinks() {
    var links = document.querySelectorAll('a[href*="/checkout"], a[href*="/checkouts"]');

    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute("href", "/cart");
      if (links[i].dataset.externalCheckoutPatched === "1") {
        continue;
      }

      links[i].dataset.externalCheckoutPatched = "1";
      links[i].addEventListener("click", handleCheckout, true);
    }
  }

  function neutralizeNativeCheckoutSubmits() {
    var buttons = document.querySelectorAll('button[name="checkout"], input[name="checkout"], [data-testid="Checkout-button"]');

    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].tagName === "BUTTON") {
        buttons[i].setAttribute("type", "button");
      }
      buttons[i].setAttribute("data-studio-external-checkout-trigger", "true");
    }

    var forms = document.querySelectorAll('form[action*="/checkout"], form[action*="/checkouts"]');

    for (var j = 0; j < forms.length; j++) {
      forms[j].setAttribute("action", "/cart");
      forms[j].setAttribute("data-studio-native-checkout-blocked", "true");
    }
  }

  function startBuyNowObserver() {
    neutralizeBuyNowButtons();
    neutralizeNativeCheckoutLinks();
    neutralizeNativeCheckoutSubmits();

    var attempts = 0;
    var interval = window.setInterval(function () {
      neutralizeBuyNowButtons();
      neutralizeNativeCheckoutLinks();
      neutralizeNativeCheckoutSubmits();
      attempts += 1;

      if (attempts > 50) {
        window.clearInterval(interval);
      }
    }, 200);

    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function () {
        neutralizeBuyNowButtons();
        neutralizeNativeCheckoutLinks();
        neutralizeNativeCheckoutSubmits();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () {
        observer.disconnect();
      }, 15000);
    }
  }

  function showOverlay() {
    if (document.getElementById("external-checkout-overlay")) {
      return;
    }

    var overlay = document.createElement("div");
    overlay.id = "external-checkout-overlay";
    overlay.setAttribute("role", "status");
    overlay.setAttribute("aria-live", "polite");
    overlay.innerHTML = '<div class="external-checkout-overlay__spinner" aria-label="Préparation du paiement"></div>';
    overlay.style.cssText = [
      "position:fixed",
      "inset:0",
      "z-index:2147483647",
      "display:flex",
      "align-items:center",
      "justify-content:center",
      "background:rgba(255,255,255,.82)",
      "backdrop-filter:blur(4px)",
      "font-family:inherit",
      "color:#111",
    ].join(";");
    overlay.firstChild.style.cssText = [
      "width:44px",
      "height:44px",
      "border:3px solid rgba(23,20,18,.14)",
      "border-top-color:#171412",
      "border-radius:999px",
      "animation:external-checkout-spin .75s linear infinite",
    ].join(";");
    if (!document.getElementById("external-checkout-style")) {
      var style = document.createElement("style");
      style.id = "external-checkout-style";
      style.textContent = "@keyframes external-checkout-spin{to{transform:rotate(360deg)}}";
      document.head.appendChild(style);
    }
    document.body.appendChild(overlay);
  }

  function removeOverlay() {
    var overlay = document.getElementById("external-checkout-overlay");

    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  }

  function resetCheckoutInterceptionState() {
    isRedirecting = false;
    removeOverlay();
  }

  function showCheckoutError(message) {
    try {
      console.warn("[Studio Mya checkout]", message);
    } catch (_error) {}
    storeDiscountCode("");
    removeOverlay();
    window.alert(message);
  }

  async function readCart() {
    var response = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Unable to read Shopify cart.");
    }

    return response.json();
  }

  async function addCurrentProductFormToCart(target) {
    if (!isBuyNowTarget(target)) {
      return;
    }

    var form = target.closest("form");

    if (!form || !(form instanceof HTMLFormElement)) {
      form = document.querySelector('form[action*="/cart/add"]');
    }

    if (!form || !(form instanceof HTMLFormElement)) {
      return;
    }

    var action = form.getAttribute("action") || "";

    if (action.indexOf("/cart/add") === -1) {
      return;
    }

    var response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
      body: new FormData(form),
    });

    if (!response.ok) {
      throw new Error("Unable to add current product to cart.");
    }
  }

  async function createExternalCheckout(cart) {
    var discountCode = readDiscountCode();
    var storedDiscountCode = readStoredDiscountCode();
    if (!discountCode && storedDiscountCode) {
      discountCode = storedDiscountCode;
    }

    var createCheckoutRequest = function (code) {
      return fetch(backendBaseUrl + "/api/create-checkout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          cart: cart,
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : undefined,
          discount_code: code,
          customer: window.__studiomyaCustomer || {},
        }),
      });
    };

    var response = await createCheckoutRequest(discountCode);

    if (!response.ok) {
      throw new Error("External checkout failed.");
    }

    return response.json();
  }

  function readDiscountCode() {
    var selectors = [
      'input[name="discount"]',
      'input[name="discount_code"]',
      'input[name="checkout[discount_code]"]',
      '[data-discount-code]',
      ".cart-discount__pill[data-discount-code]",
      ".cart-discount__pill-code",
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      var value = el && (el.dataset && el.dataset.discountCode ? el.dataset.discountCode : "value" in el ? el.value : el.textContent);

      if (value && String(value).trim()) {
        return String(value).trim().slice(0, 80);
      }
    }

    return "";
  }

  function bindCartDiscountMemory() {
    document.addEventListener(
      "input",
      function (event) {
        var target = event.target;

        if (target && target.matches && target.matches('input[name="discount"], input[name="discount_code"], input[name="checkout[discount_code]"]')) {
          storeDiscountCode(String(target.value || "").trim().slice(0, 80));
        }
      },
      true,
    );

    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;

        if (!form || !(form instanceof HTMLFormElement)) {
          return;
        }

        var input = form.querySelector('input[name="discount"], input[name="discount_code"], input[name="checkout[discount_code]"]');
        if (input) {
          storeDiscountCode(String(input.value || "").trim().slice(0, 80));
        }
      },
      true,
    );

    document.addEventListener(
      "click",
      function (event) {
        var remove = event.target && event.target.closest && event.target.closest(".cart-discount__pill-remove");

        if (remove) {
          storeDiscountCode("");
        }
      },
      true,
    );
  }

  function readStoredDiscountCode() {
    try {
      return String(sessionStorage.getItem("studio_mya_discount_code") || "").trim().slice(0, 80);
    } catch (_error) {
      return "";
    }
  }

  function storeDiscountCode(code) {
    try {
      if (code) {
        sessionStorage.setItem("studio_mya_discount_code", code);
      } else {
        sessionStorage.removeItem("studio_mya_discount_code");
      }
    } catch (_error) {}
  }

  async function handleCheckout(event, force) {
    if (isRedirecting || (!force && !isCheckoutTarget(event.target))) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    isRedirecting = true;
    showOverlay();

    try {
      await addCurrentProductFormToCart(event.target);
      var cart = await readCart();

      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
        showCheckoutError("Votre panier est vide. Ajoutez un article avant de lancer le paiement.");
        return;
      }

      var checkout = await createExternalCheckout(cart);

      if (!checkout || !checkout.checkout_url) {
        throw new Error("Missing checkout URL.");
      }

      if (checkout.session_id) {
        window.location.href =
          "/cart?external_checkout_session=" +
          encodeURIComponent(checkout.session_id) +
          "&checkout_token=" +
          encodeURIComponent(checkout.checkout_token || "");
        return;
      }

      window.location.href = checkout.checkout_url;
    } catch (error) {
      showCheckoutError(
        "Le paiement n'a pas pu être préparé. Aucun checkout Shopify natif ne sera lancé. Merci de réessayer depuis votre panier.",
      );
      isRedirecting = false;
    }
  }

  document.addEventListener("click", handleCheckout, true);

  window.addEventListener("pageshow", resetCheckoutInterceptionState);
  window.addEventListener("pagehide", removeOverlay);
  window.addEventListener("popstate", resetCheckoutInterceptionState);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      resetCheckoutInterceptionState();
    }
  });

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;

      if (!form || !(form instanceof HTMLFormElement)) {
        return;
      }

      var action = form.getAttribute("action") || "";
      var hasCheckoutSubmitter =
        event.submitter && event.submitter.matches && event.submitter.matches('[name="checkout"]');
      var hasCheckoutButton = form.querySelector('[name="checkout"]');

      if (hasCheckoutSubmitter || hasCheckoutButton || /\/checkouts?(?:\/)?$/.test(action)) {
        handleCheckout(event, true);
      }
    },
    true,
  );

  bindCartDiscountMemory();
  startBuyNowObserver();

  async function clearShopifyCart() {
    try {
      await fetch("/cart/clear.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      });
    } catch (_error) {}
  }

  async function renderCheckoutSuccessIfNeeded() {
    var params = new URLSearchParams(window.location.search);

    if (params.get("external_checkout_success") !== "1") {
      return;
    }

    await clearShopifyCart();

    var main = document.getElementById("MainContent") || document.querySelector("main");

    if (!main) {
      window.setTimeout(renderCheckoutSuccessIfNeeded, 50);
      return;
    }

    injectThemeCheckoutStyles();
    main.innerHTML =
      '<section class="studio-external-checkout studio-external-checkout--success">' +
      '<div class="studio-external-checkout__summary">' +
      '<div class="studio-external-checkout__head">' +
      "<h1>Paiement confirmé</h1>" +
      "<p>" +
      escapeHtml(params.get("checkout_ref") ? "Référence " + params.get("checkout_ref") : "") +
      "</p>" +
      "</div>" +
      '<div class="studio-external-checkout__success">' +
      '<p class="studio-external-checkout__order-number" id="studio-order-number">Numéro de commande en cours de génération...</p>' +
      '<p id="studio-order-status">Votre paiement est confirmé. Nous finalisons votre commande.</p>' +
      '<a href="/">Retour à la boutique</a>' +
      "</div>" +
      "</div>" +
      "</section>";

    updateSuccessOrderNumber(params);
  }

  async function updateSuccessOrderNumber(params) {
    var orderNumber = document.getElementById("studio-order-number");
    var orderStatus = document.getElementById("studio-order-status");
    var sessionId = params.get("session_id") || "";
    var checkoutToken = params.get("checkout_token") || "";

    if (!sessionId || !checkoutToken) {
      if (orderNumber) {
        orderNumber.textContent = params.get("checkout_ref") ? "Référence " + params.get("checkout_ref") : "";
      }
      if (orderStatus) {
        orderStatus.textContent = "Votre commande a bien été validée. Le panier de cette session a été vidé.";
      }
      return;
    }

    for (var attempt = 0; attempt < 24; attempt += 1) {
      try {
        var response = await fetch(
          backendBaseUrl +
            "/api/checkout-status?session_id=" +
            encodeURIComponent(sessionId) +
            "&checkout_token=" +
            encodeURIComponent(checkoutToken),
        );
        var status = await response.json();

        if (response.ok && status.shopify_order_name) {
          if (orderNumber) {
            orderNumber.textContent = "Commande " + status.shopify_order_name;
          }
          if (orderStatus) {
            orderStatus.textContent = "Votre commande a bien été validée. Le panier de cette session a été vidé.";
          }
          return;
        }
      } catch (_error) {}

      await wait(1500);
    }

    if (orderNumber) {
      orderNumber.textContent = params.get("checkout_ref") ? "Référence " + params.get("checkout_ref") : "";
    }
    if (orderStatus) {
      orderStatus.textContent = "Paiement confirmé. Votre numéro de commande sera disponible dans l'email de confirmation.";
    }
  }

  async function renderThemeCheckoutIfNeeded() {
    var params = new URLSearchParams(window.location.search);
    var sessionId = params.get("external_checkout_session");
    var checkoutToken = params.get("checkout_token") || "";

    if (!sessionId) {
      return;
    }

    var main = document.getElementById("MainContent") || document.querySelector("main");

    if (!main) {
      window.setTimeout(renderThemeCheckoutIfNeeded, 50);
      return;
    }

    main.innerHTML =
      '<section class="studio-external-checkout">' +
      '<div class="studio-external-checkout__summary">' +
      '<div class="studio-external-checkout__head"><h1>Votre commande</h1><p id="studio-checkout-ref"></p></div>' +
      '<div id="studio-checkout-items" class="studio-external-checkout__items"><p>Chargement du panier...</p></div>' +
      '<form id="studio-discount-form" class="studio-external-checkout__discount">' +
      '<label for="studio-discount-code">Code promo</label>' +
      '<div><input id="studio-discount-code" type="text" autocomplete="off" placeholder="Indiquez votre code"><button type="submit">Appliquer</button></div>' +
      '<p id="studio-discount-message"></p>' +
      '</form>' +
      '<div id="studio-checkout-totals" class="studio-external-checkout__totals"></div>' +
      "</div>" +
      '<div class="studio-external-checkout__payment">' +
      "<h2>Paiement</h2>" +
      '<div id="studio-stripe-checkout"><p>Chargement du paiement sécurisé...</p></div>' +
      '<p class="studio-external-checkout__notice">Votre paiement est sécurisé. Le détail de votre panier reste géré par Studio Mya.</p>' +
      "</div>" +
      "</section>";

    injectThemeCheckoutStyles();
    bindDiscountForm();

    try {
      var responses = await Promise.all([
        fetch(
          backendBaseUrl +
            "/api/checkout-session-client-secret?session_id=" +
            encodeURIComponent(sessionId) +
            "&checkout_token=" +
            encodeURIComponent(checkoutToken),
        ),
        fetch(
          backendBaseUrl +
            "/api/checkout-summary?session_id=" +
            encodeURIComponent(sessionId) +
            "&checkout_token=" +
            encodeURIComponent(checkoutToken),
        ),
      ]);
      var secret = await responses[0].json();
      var summary = await responses[1].json();

      if (responses[1].ok) {
        renderThemeSummary(summary);
      }

      if (!responses[0].ok || !secret.clientSecret || !secret.publishableKey) {
        throw new Error("Missing Stripe client secret.");
      }

      await loadStripeJs();
      var stripe = window.Stripe(secret.publishableKey);
      var checkout = await stripe.initEmbeddedCheckout({
        clientSecret: secret.clientSecret,
        onComplete: async function () {
          await clearShopifyCart();
          window.location.href =
            "/cart?external_checkout_success=1&checkout_ref=" +
            encodeURIComponent(secret.checkout_ref || "") +
            "&session_id=" +
            encodeURIComponent(sessionId) +
            "&checkout_token=" +
            encodeURIComponent(checkoutToken);
        },
      });
      document.getElementById("studio-stripe-checkout").innerHTML = "";
      checkout.mount("#studio-stripe-checkout");
    } catch (_error) {
      document.getElementById("studio-stripe-checkout").innerHTML =
        '<p class="studio-external-checkout__error">Impossible de charger le paiement. Merci de réessayer depuis votre panier.</p>';
    }
  }

  function bindDiscountForm() {
    var form = document.getElementById("studio-discount-form");
    var input = document.getElementById("studio-discount-code");

    if (!form || !input) {
      return;
    }

    input.value = readStoredDiscountCode();
    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      var code = String(input.value || "").trim().slice(0, 80);
      var message = document.getElementById("studio-discount-message");

      storeDiscountCode(code);

      if (message) {
        message.textContent = code ? "Application du code en cours..." : "Code retiré. Préparation du paiement...";
      }

      try {
        var cart = await readCart();
        var checkout = await createExternalCheckout(cart);

        if (!checkout || !checkout.session_id) {
          throw new Error("Missing checkout session.");
        }

        window.location.href =
          "/cart?external_checkout_session=" +
          encodeURIComponent(checkout.session_id) +
          "&checkout_token=" +
          encodeURIComponent(checkout.checkout_token || "");
      } catch (_error) {
        if (message) {
          message.textContent = "Code non applicable. Vous pouvez réessayer ou continuer sans code.";
        }
      }
    });
  }

  function renderThemeSummary(summary) {
    var ref = document.getElementById("studio-checkout-ref");
    var items = document.getElementById("studio-checkout-items");
    var totals = document.getElementById("studio-checkout-totals");

    if (ref) {
      ref.textContent = summary.checkout_ref ? "Reference " + summary.checkout_ref : "";
    }

    items.innerHTML = (summary.items || [])
      .map(function (item) {
        return (
          '<article class="studio-external-checkout__item">' +
          '<img src="' +
          escapeAttr(item.image || "") +
          '" alt="">' +
          "<div>" +
          '<h3>' +
          escapeHtml(item.title || "Article") +
          "</h3>" +
          "<p>Quantite " +
          item.quantity +
          "</p>" +
          (item.options && item.options.length ? "<p>" + item.options.map(escapeHtml).join(" · ") + "</p>" : "") +
          (item.properties && item.properties.length
            ? "<p>" +
              item.properties
                .map(function (property) {
                  return escapeHtml(property.name + " : " + property.value);
                })
                .join("<br>") +
              "</p>"
            : "") +
          "</div>" +
          "<strong>" +
          formatMoney(item.line_amount, summary.currency) +
          "</strong>" +
          "</article>"
        );
      })
      .join("");

    totals.innerHTML =
      '<div><span>Sous-total</span><span>' +
      formatMoney(summary.original_amount_total || summary.amount_total, summary.currency) +
      "</span></div>" +
      (summary.discount
        ? '<div><span>Code ' +
          escapeHtml(summary.discount.code) +
          "</span><span>-" +
          formatMoney(summary.discount.discount_amount, summary.currency) +
          "</span></div>"
        : "") +
      "<div><strong>Total</strong><strong>" +
      formatMoney(summary.amount_total, summary.currency) +
      "</strong></div>";
  }

  function injectThemeCheckoutStyles() {
    if (document.getElementById("studio-external-checkout-styles")) {
      return;
    }

    var style = document.createElement("style");
    style.id = "studio-external-checkout-styles";
    style.textContent =
      ".studio-external-checkout{max-width:1180px;margin:0 auto;padding:32px 18px 56px;display:grid;grid-template-columns:minmax(0,1fr) minmax(420px,520px);gap:28px;align-items:start}" +
      ".studio-external-checkout__summary,.studio-external-checkout__payment{border:1px solid rgba(30,25,20,.14);background:#fff}" +
      ".studio-external-checkout__summary{background:#faf7f4}" +
      ".studio-external-checkout__head{padding:18px;border-bottom:1px solid rgba(30,25,20,.12)}" +
      ".studio-external-checkout__head h1{margin:0;font-size:22px;line-height:1.2}" +
      ".studio-external-checkout__head p{margin:6px 0 0;color:#756e68;font-size:12px}" +
      ".studio-external-checkout__items{display:grid}" +
      ".studio-external-checkout__item{display:grid;grid-template-columns:74px minmax(0,1fr) auto;gap:14px;padding:16px 18px;background:#fff;border-bottom:1px solid rgba(30,25,20,.1)}" +
      ".studio-external-checkout__item img{width:74px;height:94px;object-fit:cover;background:#eee}" +
      ".studio-external-checkout__item h3{margin:0 0 5px;font-size:14px;line-height:1.35}" +
      ".studio-external-checkout__item p{margin:0 0 4px;color:#756e68;font-size:12px;line-height:1.45}" +
      ".studio-external-checkout__item strong{font-size:14px;white-space:nowrap}" +
      ".studio-external-checkout__totals{padding:16px 18px;background:#fff;display:grid;gap:10px}" +
      ".studio-external-checkout__discount{padding:16px 18px;background:#fff;border-bottom:1px solid rgba(30,25,20,.1);display:grid;gap:8px}" +
      ".studio-external-checkout__discount label{font-size:12px;text-transform:uppercase;letter-spacing:.04em;color:#756e68}" +
      ".studio-external-checkout__discount div{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px}" +
      ".studio-external-checkout__discount input{min-width:0;border:1px solid rgba(30,25,20,.18);padding:11px 12px;font:inherit;background:#fff;color:inherit}" +
      ".studio-external-checkout__discount button{border:1px solid #171412;background:#171412;color:#fff;padding:0 14px;font:inherit;cursor:pointer}" +
      ".studio-external-checkout__discount p{margin:0;color:#756e68;font-size:12px;line-height:1.4}" +
      ".studio-external-checkout__totals div{display:flex;justify-content:space-between;gap:18px;color:#756e68;font-size:14px}" +
      ".studio-external-checkout__totals strong{color:#171412;font-size:18px}" +
      ".studio-external-checkout__payment{padding:18px;position:sticky;top:18px}" +
      ".studio-external-checkout__payment h2{font-size:18px;margin:0 0 14px}" +
      ".studio-external-checkout__notice{margin:14px 0 0;color:#756e68;font-size:12px;line-height:1.5}" +
      ".studio-external-checkout__error{color:#9d2b20;font-size:14px;line-height:1.5}" +
      ".studio-external-checkout__success{padding:18px;background:#fff;display:grid;gap:14px;font-size:14px;line-height:1.5}" +
      ".studio-external-checkout__success p{margin:0;color:#171412}" +
      ".studio-external-checkout__order-number{font-size:20px;font-weight:700}" +
      ".studio-external-checkout__success a{justify-self:start;border:1px solid #171412;background:#171412;color:#fff;padding:11px 14px;text-decoration:none}" +
      ".studio-external-checkout--success{grid-template-columns:minmax(0,720px);justify-content:center}" +
      "@media(max-width:900px){.studio-external-checkout{grid-template-columns:1fr;padding:18px 12px 40px}.studio-external-checkout__payment{position:static}.studio-external-checkout__item{grid-template-columns:62px minmax(0,1fr);gap:12px}.studio-external-checkout__item img{width:62px;height:80px}.studio-external-checkout__item strong{grid-column:2}}";
    document.head.appendChild(style);
  }

  function loadStripeJs() {
    if (window.Stripe) {
      return Promise.resolve();
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = "https://js.stripe.com/v3/";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: String(currency || "eur").toUpperCase(),
    }).format(Number(cents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, "&#96;");
  }
})();
